import { apiV1 } from "./constants";
import { PrepareMessageBodyResultType } from "./types";

export const getPrepareMessageBody = (body: string[]): Promise<PrepareMessageBodyResultType> =>
  apiV1.post("message/prepare", { json: { toExternalIds: body } }).json();

export const sendMessage = (toExternalIds: string[], message: string) =>
  apiV1.post("message/send", { json: { toExternalIds, message } }).json();
